import { useMutation } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { MFA_METHOD } from 'utils/constants';
import { useProvider } from 'utils/providers/Provider';
import { ApiError } from 'utils/types';

interface Payload {
  method: MFA_METHOD;
}

export default function useLoginNominate() {
  const { state } = useProvider();
  const args = state;

  return useMutation<any, ApiError, Payload, any>({
    mutationFn: async (payload) => {
      const api = new Api(args);

      const data = await api.post({
        url: 'api/v1/auth/accounts/mfa',
        payload,
      });

      return data;
    },
  });
}
